import ApiClient from "@/api/ApiClient.ts";
import { sortByKeyValue } from "@/utils/sorters";

const state = {
  historicTrips: [],
  historicTripsData: {},
  historicTripsWithFilters: [],
  historicTripsDataRecycler: {},
  historicTripsHome: [],
};

const mutations = {
  setHistoricTrips(state, trips) {
    state.historicTrips = trips;
  },

  setHistoricTripsData(state, data) {
    state.historicTripsData = data;
  },

  setHistoricTripsWithFilters(state, trips) {
    state.historicTripsWithFilters = trips;
  },

  setHistoricTripsDataRecycler(state, data) {
    state.historicTripsDataRecycler = data;
  },

  setHistoricTripsHome(state, trips) {
    state.historicTripsHome = trips;
  },
};

const actions = {
  async getHistoricTrips({ commit }, customParams) {
    const params = {
      viewMode: "resumed",
      ...customParams,
    };
    try {
      const api = ApiClient();
      let response = await api.get("/trips/historic", { params });
      commit("setHistoricTrips", response.data);
      return response.data;
    } catch (error) {
      console.error("ERROR en getHistoricTrips: ", error.message);
    }
  },

  async getHistoricTripsHistoric({ commit }, customParams) {
    const params = {
      mode: "tripHistoricWindow2",
      ...customParams,
    };
    try {
      const api = ApiClient();
      let response = await api.get("/trips/historic2", { params });
      commit("setHistoricTrips", response.data);
      return response.data;
    } catch (error) {
      console.error("ERROR en getHistoricTrips: ", error.message);
    }
  },

  async getHistoricTripsPagination(_, customParams) {
    const params = {
      mode: "pagination",
      ...customParams,
    };
    try {
      const api = ApiClient();
      let response = await api.get("/trips/historic2", { params });
      return response.data;
    } catch (error) {
      console.error("ERROR en getHistoricTrips: ", error.message);
    }
  },

  setHistoricTripsWithFilters({ commit }, historicTrips) {
    commit("setHistoricTripsWithFilters", historicTrips);
  },
};

const getters = {
  historicTrips(state) {
    return state.historicTrips;
  },

  historicTripsData(state) {
    return state.historicTripsData;
  },

  historicTripsWithFilters(state) {
    return state.historicTripsWithFilters;
  },

  historicTripsDataRecycler(state) {
    return state.historicTripsDataRecycler;
  },

  historicTripsHome(state) {
    if (state.historicTripsHome?.length) {
      return state.historicTripsHome
        .filter((trip) => trip.state !== 21)
        .sort(sortByKeyValue("service.date"))
        .reverse();
    } else {
      return [];
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
